// Suppress harmless errors/warnings from third-party libraries - MUST be before imports
// Event listeners must be registered first to capture before react-error-overlay
const shouldSuppressAbortError = (value: any) => {
  const message = value?.message || value?.reason?.message || '';
  const name = value?.name || value?.reason?.name || '';
  const asString = String(value);
  return name === 'AbortError' || message.includes('signal is aborted') || asString.includes('AbortError');
};

window.addEventListener(
  'unhandledrejection',
  (event) => {
    const reason = event.reason;
    if (shouldSuppressAbortError(reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      return false;
    }
  },
  true,
);

window.addEventListener(
  'error',
  (event) => {
    const error = event.error;
    const message = event.message || '';
    if (shouldSuppressAbortError(error) || shouldSuppressAbortError(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      return false;
    }
  },
  true,
);

const suppressedPatterns = [
  'AbortError',
  'signal is aborted',
  'signal is aborted without reason',
  "don't support the second callback argument",
  'useNativeDriver',
  'componentWillMount has been renamed',
  'componentWillReceiveProps has been renamed',
  'Math.random is not cryptographically secure',
  'findDOMNode is deprecated',
];

const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

console.error = (...args: any[]) => {
  const message = args[0]?.toString?.() || '';
  const error = args[0];

  // Check if it's an AbortError
  if (
    error?.name === 'AbortError' ||
    error?.message?.includes('signal is aborted') ||
    message.includes('AbortError') ||
    message.includes('signal is aborted')
  ) {
    return;
  }

  if (suppressedPatterns.some((pattern) => message.includes(pattern))) {
    return;
  }
  originalConsoleError.apply(console, args);
};

console.warn = (...args: any[]) => {
  const message = args[0]?.toString?.() || '';
  if (suppressedPatterns.some((pattern) => message.includes(pattern))) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import './scss/main.scss';
// ToDo: времянка для демо - удалить
import './screens/cardServices/style.scss';
import './shared/components/menu/components/dropdownMenu/style.scss';
import './screens/profile/common/applications/style.scss';
import './shared/components/visuallyImpaired/button/style.scss';
import './screens/news/components/allNews/newsItem/style.scss';
import 'swiper/swiper.scss';
import App from './app';
import * as serviceWorker from './serviceWorker';
import {AppErrorBoundary, AppErrorFallback} from './shared/appErrorBoundary';
import {setDefaultOptions} from 'date-fns';
import {ru} from 'date-fns/locale';
setDefaultOptions({locale: ru});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <AppErrorBoundary
    onError={(error, errorInfo) => {
      if (process.env.NODE_ENV !== 'production') {
        console.error('AppErrorBoundary', error, errorInfo);
      }
    }}
    FallbackComponent={(props) => <AppErrorFallback {...props} />}>
    <App />
  </AppErrorBoundary>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
